module.exports = __webpack_public_path__ + "img/trinapp-files.19aca304.png";